export default defineNuxtPlugin({
  name: 'errors',
  dependsOn: ['observability'],
  setup(nuxtApp) {
    const o11y = useO11y();

    nuxtApp.hook('vue:error', (error, _instance, info) => {
      console.error('[vue:error]', error, info);
      o11y.reportError(error, { info });
    });

    nuxtApp.hook('app:error', (...args) => {
      const firstError = args[0];
      if (!firstError) return;

      console.error('[app:error]', firstError);
      o11y.reportError(firstError);
    });
  },
});
